const baseRoute = "/user"

export const userRoutes = {
    DASHBOARD: `${baseRoute}/dashboard`,
    PAYMENT: `${baseRoute}/payment`,
    PAYMENT_FEEDBACK: `${baseRoute}/payment/feedback`,
}